export const isError = code => code >= 400 && code < 600

export const isRedirection = code => code >= 300 && code < 400

export const isNotFound = code => code === 404
